import request from '../network';

export interface FieldDictParams {
  fieldCode?: string;
  petType?: string;
}

export interface FieldDictItem {
  dictCode?: string;
  dictName?: string;
}

export const getPetFieldDictListApi = (data: FieldDictParams) => {
  return request({
    url: '/member/royalcanin/admin/petFieldDict/getFieldDictList',
    method: 'POST',
    data,
  });
};

export const getPetFieldListApi = () => {
  return request({
    url: '/member/royalcanin/admin/petFieldDict/getFieldList',
    method: 'POST',
  });
};
